// extracted by mini-css-extract-plugin
export default {"watermarkOverlay":"watermarkOverlay__GDehX","watermarkUnit":"watermarkUnit__4nB3p","watermarkLine":"watermarkLine__2Ad+H"};